import {
  createErrorOperationResult,
  createSuccessOperationResult,
} from '@hc-frontend/core-utils-business-operation';
import {
  GetExternalLeadResponseStatus,
  getExternalLeadService,
} from '@hc-frontend/services';
import { find } from 'ramda';

import type { GetAnswersRepository, PartialSurveyAnswers } from '../../domain';

export function getAnswersAdapterFactory({
  baseUrl,
}: {
  baseUrl: string;
}): GetAnswersRepository {
  return {
    getAnswers: async (params) => {
      if (!params.sessionId && !params.userId) {
        return createErrorOperationResult({
          errors: [
            {
              code: 'failedToGetAnswers',
            },
          ],
        });
      }

      const response = await getExternalLeadService({ baseUrl })({
        ...params,
        leadStatusId: GetExternalLeadResponseStatus.PROSPECT.toString(),
      });

      if (response.status !== 200 || response.body === undefined) {
        return createErrorOperationResult({
          errors: [
            {
              code: 'failedToGetAnswers',
              rootCause: new Error(
                `Session ${params.sessionId} could not be retreived`,
              ),
            },
          ],
        });
      }

      const askForZipCode = find(
        (val) => val.name === 'askForZipCode',
        response.body.journeyAttributes,
      );

      const isPhoenix = find(
        (val) => val.name === 'is_phoenix',
        response.body.journeyAttributes,
      );

      const isOep = find(
        (val) => val.name === 'is-oep',
        response.body.journeyAttributes,
      );

      const answers: PartialSurveyAnswers = {
        ASK_FOR_ZIP_CODE:
          askForZipCode?.value === 'false'
            ? false
            : Boolean(askForZipCode?.value),
        IS_PHOENIX:
          isPhoenix?.value === 'false' ? false : Boolean(isPhoenix?.value),
        IS_OEP: isOep?.value === 'is-oep-yes',
      };

      return createSuccessOperationResult(answers);
    },
  };
}
